import { pricing } from "../utils/pricing";
import { getPricingObject } from "./product";

class AddButton {
  /**
   * set add button to available.
   */
  setActive() {
    const productButtonElement = document.querySelector(".product-add-button");
    const submitElement = document.querySelector(".product-add-button button");
    const textElement = submitElement.querySelector(".button__text");

    submitElement.classList.remove("js-ghost");
    submitElement.classList.remove("js-email");
    submitElement.classList.add("js-active");
    submitElement.disabled = false;
    textElement.innerHTML = window.variantStrings.add_to_cart;

    productButtonElement.innerHTML = `
      ${submitElement.outerHTML}
    `;
  }

  /**
   * Set add button to make selection first state.
   */
  setMakeSelection() {
    const submitElement = document.querySelector(".product-add-button button");
    const textElement = submitElement.querySelector(".button__text");

    submitElement.classList.add("js-ghost");
    submitElement.classList.remove("js-active");
    submitElement.classList.remove("js-email");
    submitElement.disabled = true;

    textElement.innerHTML = window.variantStrings.make_selection;
  }

  /**
   * Set add to cart button to disabled.
   */
  setDisabled() {
    const productButtonElement = document.querySelector(".product-add-button");
    const submitElement = document.querySelector(".product-add-button button");
    const textElement = submitElement.querySelector(".button__text");

    submitElement.disabled = true;
    submitElement.classList.remove("js-ghost");
    submitElement.classList.remove("js-active");
    submitElement.classList.add("js-email");
    textElement.innerHTML = `
      <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.0001 1L7 6.24219L1.00014 1M13.0001 1H1.00014M13.0001 1L13 9H1L1.00014 1" stroke="#FBFBF6" stroke-width="0.75"/>
      </svg>

      ${window.variantStrings.email_me}
    `;

    productButtonElement.innerHTML = `
      ${submitElement.outerHTML}
    `;
  }

  /**
   * Update price in add button..
   */
  updatePrice() {
    const pricingObject = getPricingObject();

    if (pricingObject.mainProductPrice) {

      const priceHolderElement = document.querySelector(
        ".product-add-button .price-holder"
      );

      if (pricingObject.compareAtPrice) {
        priceHolderElement.innerHTML = `
          <p class="price price--underlined">${pricing(
            pricingObject.compareAtPrice
          ).replace(".00", "")}</p>
          <p class="price price--has-compare-price">${pricing(
            pricingObject.total.price
          ).replace(".00", " ")}</p>
        `;
      } else {
        priceHolderElement.innerHTML = `
          <p class="price">${pricing(pricingObject.total.price)}</p>
        `;
      }
    }
  }
}

export default new AddButton();
